export default "__VITE_ASSET__MssyGsQH__"